import { ReactNode } from 'react'
import { Redirect } from 'react-router'

import { AuthenticatedUser } from '@apps-common/types/portal'
import { Route, RouteType } from '@apps-common/types/routes'
import { buildAuthRedirectPath, getSafeRedirectPath } from './auth-redirect'

interface IRouteRendererRedirect {
  authenticated: Route
  unauthenticated: Route
}

export const routeRenderer = (
  user: AuthenticatedUser | null,
  component: ReactNode,
  routeType: RouteType,
  redirects: IRouteRendererRedirect
): ReactNode => {
  const currentPath =
    typeof window === 'undefined' ? redirects.authenticated.path : `${window.location.pathname}${window.location.search}${window.location.hash}`
  const authenticatedRedirectPath = typeof window === 'undefined' ? redirects.authenticated.path : getSafeRedirectPath(window.location.search, redirects.authenticated.path)
  const unauthenticatedRedirectPath = buildAuthRedirectPath(redirects.unauthenticated.path, currentPath)

  if (routeType === 'public') {
    if (!user) {
      return component
    }

    return <Redirect to={authenticatedRedirectPath} />
  }

  if (routeType === 'private') {
    if (!user) {
      return <Redirect to={unauthenticatedRedirectPath} />
    }

    return component
  }

  if (routeType === 'admin') {
    // TODO: check for admin privileges against user account
    if (!user) {
      return <Redirect to={unauthenticatedRedirectPath} />
    }

    return component
  }

  if (routeType === 'super') {
    // TODO: check for super privileges against user account
    if (!user) {
      return <Redirect to={unauthenticatedRedirectPath} />
    }

    return component
  }

  return <Redirect to={authenticatedRedirectPath} />
}
